
import React, { useEffect, useState } from "react";
import styles from "./index.module.less";
import { Cell, Edge, Node } from "@antv/x6"
import { useGraphInstance } from "@antv/xflow"
import { NodeShapes, NodeState } from "@/components/FlowSheetEditor/services/modal"
import { cellToNodeState } from "@/components/FlowSheetEditor/services/storage"
import { NodeUnitPanel } from "../UnitPanel/UnitPanel"
import { NodeStreamPanel } from "../UnitPanel/components/StreamUnit/SvgStream"
import { ImageNodePanel } from "../BasicNodePanel/ImageNodePane"
import { TextNodePanel } from "../BasicNodePanel/TextNodePane"

interface NodeCellPanelProps {
  cell: Node
  onChange?: () => void
}

type CellData = NodeState | Cell.Properties

function getPanelData(unit: Node | undefined): CellData | null  {
  if (!unit) return null;
  if (unit.shape === NodeShapes.SvgNode) {
    return cellToNodeState(unit.toJSON())
  } else if (unit.shape === NodeShapes.SvgStream) {
    return unit.toJSON()
  } else if (unit.shape === NodeShapes.LineJump) {
    return unit.toJSON()
  } else {
    return null
  }
}


export const NodeCellPanel = (props: NodeCellPanelProps) => {
  const {cell, onChange} = props
  const [data, setData] = useState<CellData | null>(getPanelData(cell))
  const graph = useGraphInstance()

  useEffect(() => {
    if (!graph || !cell) return;
    const fsUnit = cell as Node | Edge
    const callback = ({cell}) => {
      const cellId = cell.id
      if (cellId === fsUnit?.id) {
        const newCell = graph?.getCellById(cellId)
        setData(getPanelData(newCell as Node))
      }
    }
    graph!.on('cell:changed', callback)
    graph!.on('cell:removed', callback)

    return () => {
      graph!.off('cell:changed', callback)
      graph!.off('cell:removed', callback)
    }
  }, [cell])

  if (!cell) return null;
  let content: any = null
  if (cell.shape === NodeShapes.SvgNode && data) {
    content = <NodeUnitPanel unit={data as NodeState} onChange={onChange} />
  } else if (cell.shape === NodeShapes.SvgStream || cell.shape === NodeShapes.LineJump) {
    const cellData = data as Cell.Properties
    const streamId = cellData.data.streamId;
    content = <NodeStreamPanel streamId={streamId} />
  } else if (cell.shape === NodeShapes.ImageNode) {
    content = <ImageNodePanel unit={cell} />
  } else if (cell.shape === NodeShapes.TextNode) {
    content = <TextNodePanel unit={cell} />
  }

  return <div className={styles.rightPanel}>
    {content}
  </div>
}